import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';
import { IntervalsDuration } from '../enums/intervals-duration.enum';

@Pipe({
  name: 'intervalDurationResolver',
  standalone: true,
})
export class IntervalDurationResolverPipe implements PipeTransform {
  private readonly translationKeys = {
    [IntervalsDuration.HOURS]: 'general.units.time.hour.pl',
    [IntervalsDuration.DAYS]: 'general.units.time.day.pl',
    [IntervalsDuration.MONTHS]: 'general.units.time.month.pl',
    [IntervalsDuration.YEARS]: 'general.units.time.year.pl',
  };

  constructor(private languageService: LanguageService) {}

  public transform(interval: IntervalsDuration): string {
    return this.translationKeys[interval]
      ? this.translate(this.translationKeys[interval])
      : this.translate('general.unknown').toLowerCase();
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
